import { render } from "./FounderInfo.vue?vue&type=template&id=aaeb9e34&scoped=true"
import script from "./FounderInfo.vue?vue&type=script&lang=js"
export * from "./FounderInfo.vue?vue&type=script&lang=js"

import "./FounderInfo.vue?vue&type=style&index=0&id=aaeb9e34&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaeb9e34"]])

export default __exports__